import { CallOutAlertVariant, } from '../../../../../../components/callOutAlert/types/callOutAlertTheme';
import { commonStyles, containersCommonStyles } from '../commonStyles';
export const getImageStyles = (FOUNDATIONS, FONT, SHADOWS) => {
    return {
        [CallOutAlertVariant.IMAGE]: {
            ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS),
            ...commonStyles(FOUNDATIONS, FONT, SHADOWS),
            container: {
                ...containersCommonStyles(FOUNDATIONS, FONT, SHADOWS).container,
                padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_250} ${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_100}`,
            },
            image: {
                cursor: 'pointer',
                width: '60px',
                max_width: FOUNDATIONS.size_650,
                background_size: '100% 100%',
                background_position: '50%, 50%',
                position: 'relative',
                display: 'inline-flex',
                justify_content: 'center',
                align_items: 'center',
                border_radius: `${FOUNDATIONS.radius_200} 0 0 ${FOUNDATIONS.radius_200}`,
            },
        },
    };
};
//# sourceMappingURL=image.js.map